// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".access-token__icons[data-v-7f8b4fee] {\n  font-size: 1rem;\n}\n.snackbar-button[data-v-7f8b4fee] {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n", ""]);
// Exports
module.exports = exports;
